var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEuroSign = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M48.1 272H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h28.3c-7.1-20.1-11.3-41.6-12.1-64zm82 64H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H112.2c1.2 23.1 7.5 44.8 17.9 64m-17.9-96H256c17.7 0 32-14.3 32-32s-14.3-32-32-32H130.1c-10.4 19.2-16.7 40.9-17.9 64m-51.9-64H32c-17.7 0-32 14.3-32 32s14.3 32 32 32h16.1c.8-22.4 5-43.9 12.1-64z",
  style: {
    opacity: 0.4
  }
}), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M48 248c0-119.3 96.7-216 216-216h24c17.7 0 32 14.3 32 32s-14.3 32-32 32h-24c-83.9 0-152 68.1-152 152v16c0 83.9 68.1 152 152 152h24c17.7 0 32 14.3 32 32s-14.3 32-32 32h-24c-119.3 0-216-96.7-216-216z",
  className: "euro-sign_svg__fa-primary"
})));
export default SvgEuroSign;